import Data from '../../data/main/config/setup/form/forms'

const state = {
  draftFormType: Data.forms.rechteck.type[0].draftFormType
}

const mutations = {
  'SET_DRAFT_FORM_TYPE' (state, type) {
    state.draftFormType = type
  }
}

const actions = {
  setDraftFormType: ({ commit }, type) => {
    commit('SET_DRAFT_FORM_TYPE', type)
  }
}

const getters = {
  draftFormType: state => {
    return state.draftFormType
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
